export function isActive(value: any): boolean {
  // Caso 1: booleano directo
  if (typeof value === 'boolean') return value;

  // Caso 2: fecha tipo deletedAt (activo si NO tiene fecha)
  
  if (typeof value === 'string') {
    const v = value.toUpperCase().trim();

    // Si el string es un código tipo 'A', 'I', etc.
    if (v === 'A' || v === 'ACTIVE' || v === 'ACTIVO') return true;
    if (v === 'I' || v === 'INACTIVE' || v === 'INACTIVO') return false;

    const date = new Date(value)
    if (!isNaN(date.getTime())) return false;
    //si tiene fecha, es porqué está inactivo/eliminado, entonces es retorna false.
    //si no tiene fecha, es un registro activo, entonces es retorna false.
  }

  if (!value) return true;

  // Caso 5: fallback numérico o truthy
  return Boolean(value);
}
